import { QUERY_PRESETS } from "@/queries/queryTimeConfig";

export const paymentTypesConfig = {
  getPaymentTypes: {
    key: "getPaymentTypes",
    url: "/api/v1/payment-types",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  getMyPropertyPaymentTypes: {
    key: "getMyPropertyPaymentTypes",
    url: "/api/v1/payment-types/my-property",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  createPaymentType: {
    key: "createPaymentType",
    url: "/api/v1/payment-types",
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: ["getPaymentTypes"],
      onSuccessMessage: "Payment type added successfully",
      onErrorMessage: "Failed to add payment type",
    },
  },

  updatePaymentType: {
    key: "updatePaymentType",
    url: ({ id }) => `/api/v1/payment-types/${id}`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: ["getPaymentTypes"],
      onSuccessMessage: "Payment type updated successfully",
      onErrorMessage: "Failed to update payment type",
    },
  },

  deletePaymentType: {
    key: "deletePaymentType",
    url: ({ id }) => `/api/v1/payment-types/${id}`,
    method: "DELETE",
    options: {
      retry: 2,
      invalidateKeys: ["getPaymentTypes"],
      onSuccessMessage: "Payment type removed successfully",
      onErrorMessage: "Failed to remove payment type",
    },
  },
};
